import styled from '@emotion/styled'
import { calcRem } from '../../../__styling/style-functions/calc-rem'

export const StyledSpan = styled('span')({
    width: '100%',
    marginLeft: calcRem(5),
    fontWeight: 700,
    textTransform: 'uppercase',
    color: '#464646',
    fontFamily: 'Oxygen, Arial',
    fontSize: calcRem(13),
})

export const StyledDiv = styled('div')({
    display: 'flex',
    alignItems: 'center',
    paddingTop: calcRem(5),
    paddingBottom: calcRem(7),
})
